module.exports = " <input type=file name=fileUpload @change=onFileChange> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/FileUpload.vue
// module id = 2
// module chunks = 0